import React from 'react';
import FilterFooter from './FilterFooter';
import { useIntl } from 'react-intl';
import css from './FilterModal.module.css';
import FilterComponent from '../FilterComponent';
import { CustomModal } from '../../../components';

const FilterModal = ({
  getHandleChangedValueFn,
  isOpen,
  onClose,
  onManageDisableScrolling,
  availableFilters,
  initialValues,
  urlQueryParams,
  totalItems,
  resetAll,
  listingCategories,
  marketplaceCurrency,
}) => {
  const intl = useIntl();

  return (
    <CustomModal
      id="CustomModal.filters"
      isOpen={isOpen}
      onClose={onClose}
      header="Filters"
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.allFilters}>
        {availableFilters?.map(config => {
          const key = `SearchFiltersMobile.${config.scope || 'built-in'}.${config.key}`;
          return (
            <FilterComponent
              key={key}
              idPrefix="SearchFiltersMobile"
              className={css.filter}
              config={config}
              urlQueryParams={urlQueryParams}
              initialValues={initialValues}
              getHandleChangedValueFn={getHandleChangedValueFn}
              liveEdit
              showAsPopup={false}
              isDesktop
              listingCategories={listingCategories}
              marketplaceCurrency={marketplaceCurrency}
              intl={intl}
            />
          );
        })}
      </div>
      <FilterFooter
        handleResetAll={resetAll}
        onSetFilterModalOpen={onClose}
        totalItems={totalItems}
      />
    </CustomModal>
  );
};

export default FilterModal;
